import _ from 'lodash'

export default {
  buildErrors: (apiErrors) => {
    const e = {}
    if (apiErrors instanceof Array) {
      apiErrors.forEach(v => {
        if (v.field) {
          e[_.camelCase(v.field)] = v.message
        } else {
          Object.keys(v).forEach(k => {
            e[_.camelCase(k)] = v[k][0]
          })
        }
      })
    }
    return e
  }
}
